import { AdminPanelSettings } from '@mui/icons-material'
import AuditList from './list'

const exp = {
  icon: AdminPanelSettings,
  list: AuditList
}

export default exp
